import { AppLanguage } from './types';

/** Labels for supplier admin UI (always Serbian). */
export const CUSTOMER_LANGUAGE_OPTIONS: { label: string; value: AppLanguage }[] = [
  { label: 'Srpski', value: 'sr' },
  { label: 'Engleski', value: 'en' },
  { label: 'Nemački', value: 'de' },
  { label: 'Poljski', value: 'pl' },
  { label: 'Češki', value: 'cs' },
  { label: 'Francuski', value: 'fr' }
];
